export const PATIENT_MISCELLANEOUS_OPTIONS = {
  PREFERRED_PROVIDER_FULL_NAME: "Patient.PreferredProviderFullName",
  PREFERRED_PROVIDER_SIGNATURE: "Patient.PreferredProviderSignature",
  PREFERRED_CLINIC: "Patient.PreferredClinic",
  SEGMENT: "Patient.Segment",
  REFERRAL_SOURCE: "Patient.ReferralSource",
  SUB_REFERRAL_SOURCE: "Patient.SubReferralSource",
  TAGS: "Patient.Tags",
  HIPAA_SIGNED_DATE: "Patient.HipaaSignedDate",
  CONSENT_SIGNED_DATE: "Patient.ConsentSignedDate",
  SIGNATURE: "Patient.Signature",
  DIAGNOSIS_CODES: "Patient.DiagnosisCodes"
};
